import { render } from "./PlusCircleIcon.vue?vue&type=template&id=6a34faca"
import script from "./PlusCircleIcon.vue?vue&type=script&lang=js"
export * from "./PlusCircleIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__